import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import LocaleKeys from '../../../../locales/keys';

const useStyles = makeStyles((theme) => ({
  headerLabel: {
    fontFamily: 'Formula1-Bold',
    fontWeight: 700,
    fontSize: '18px',
    textTransform: 'uppercase',
    [theme.breakpoints.between('xs', 'md')]: {
      lineHeight: 1.43,
    },
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.between('xs', 'md')]: {
      flexDirection: 'column',
      rowGap: theme.spacing(2),
      alignItems: 'center',
    },
  },
  externalHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.between('xs', 'md')]: {
      flexDirection: 'column',
      rowGap: theme.spacing(2),
    },
  },
  toggleButtonContainer: {
    display: 'flex',
    border: '1px solid #dfdedc',
    background: '#dfdedc',
    padding: '4px',
    borderRadius: '16px',
    width: 'min-content',
    height: '30px',
  },
  toggleButtonStyles: {
    borderRadius: '30px !important',
    textTransform: 'none',
    padding: '4px 12px',
    border: 0,
    color: '#000000',
    '&.MuiToggleButton-root.Mui-selected': {
      backgroundColor: '#000000',
      color: '#ffffff',
    },
  },
  toggleTypography: {
    textTransform: 'none',
    fontWeight: 700,
  },
}));

const HeaderWithToggleButton = ({
  billCycle,
  handleBillCycle,
  headerLabel,
  toggleDisabled,
  isExternal,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box
      className={
        isExternal ? classes.externalHeaderContainer : classes.headerContainer
      }
    >
      <Typography className={classes.headerLabel}>{headerLabel}</Typography>
      {billCycle && (
        <Box className={classes.toggleButtonContainer}>
          <Box display="flex">
            <ToggleButtonGroup
              value={billCycle}
              onChange={handleBillCycle}
              aria-label="bill_cycle"
              exclusive
            >
              <ToggleButton
                className={classes.toggleButtonStyles}
                value="monthly"
                aria-label="Monthly"
                disabled={toggleDisabled.monthly}
              >
                <Typography
                  className={classes.toggleTypography}
                  variant="button"
                >
                  {t(LocaleKeys.subscriptionInfo.subscriptions.monthly)}
                </Typography>
              </ToggleButton>
              <ToggleButton
                className={classes.toggleButtonStyles}
                value="yearly"
                aria-label="Yearly"
                disabled={toggleDisabled.yearly}
              >
                <Typography
                  variant="button"
                  className={classes.toggleTypography}
                >
                  {t(LocaleKeys.subscriptionInfo.subscriptions.yearly)}
                </Typography>
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default HeaderWithToggleButton;
